import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04a85a74&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a85a74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a85a74')) {
      api.createRecord('04a85a74', component.options)
    } else {
      api.reload('04a85a74', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04a85a74&scoped=true", function () {
      api.rerender('04a85a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit/index.vue"
export default component.exports